import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom';
import Cookies from 'js-cookie';

const FoodList = () => {

  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);
  const [donations, setDonations] = useState([]);
  const [selectedContact, setSelectedContact] = useState(null); // Track the selected contact
  const navigate =  useNavigate();
  const userId = Cookies.get('user'); // replace 'userId' with your actual cookie key


  // Redirect to login if token not found
  

  const fetchDonations = async () => {
    setIsLoading(true);
    setError(null);
    try {
      const response = await fetch(`${process.env.REACT_APP_MODE === 'development' ? "http://localhost:8000/api/v1" : `${process.env.REACT_APP_API_URL}`}/user/donations`,);
      const data = await response.json();
      setDonations(data.data);
      console.log(data.data);
      setIsLoading(false);


    } catch (error) {
      console.error('Error fetching donations:', error);
      setIsLoading(false);
      setError('No donations found.');
    }
  };


  useEffect(() => {

    //  Cookies.get('token') ? console.log("Token found") : navigate('/login');
    fetchDonations();
  }, []);


  const handleContactClick = (contact) => {
    setSelectedContact(contact);
  };
  

  const handleInterestClick = async (donationId) => {
    const token = Cookies.get('token'); // replace 'token' with your actual cookie key

    if (!token) {
      navigate('/login'); // Redirect to login if token not found
      alert('Please login to express your interest.');
      return;
    }
    try {
      const response = await fetch(`${process.env.REACT_APP_MODE === 'development' ? "http://localhost:8000/api/v1" : `${process.env.REACT_APP_API_URL}`}/user/donation/${donationId}/${userId}/interested`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
        },
      });
  
      const result = await response.json();
  
      if (response.ok) {
        alert('Are you sure you want this donation?');
        fetchDonations(); // Refetch donations to update the state
        // Optionally refetch donations or update local state
      } else {
        alert('Failed to update status: ' + result.message);
      }
    } catch (error) {
      console.error('Error marking as interested:', error);
      alert('Something went wrong.');
    }
  };
  







  return (
    <div className="">
    <div className='align-middle text-center m-2 mb-7'>
       <span className='mb-2 mu-2 text-2xl font-extrabold leading-none tracking-tight text-gray-900 md:text-5xl lg:text-6xl '>Food </span><span className='mb-2 mu-2 text-2xl font-extrabold leading-none tracking-tight text-green-500 md:text-5xl lg:text-6xl '>Availability </span>
    </div>

  
 

    {isLoading && 
    <div className="text-center mt-4 h-96 flex items-center justify-center">


    <div role="status">
    <svg aria-hidden="true" class="inline w-20 h-20 text-gray-200 animate-spin dark:text-gray-600 fill-green-500" viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z" fill="currentColor"/>
        <path d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z" fill="currentFill"/>
    </svg>
    <span class="sr-only">Loading...</span>
</div>
      
      
      
      
    </div>}

    



   



    {!isLoading && donations.map((donation) => (
  // <DonationCard key={donation._id} donation={donation} />


  


<>



{  !donation.accepted && !donation.notAccepted && (

  <div className="flex flex-wrap md:flex-nowrap border-2 m-4 rounded-lg shadow-lg mx-auto max-w-3xl group cursor-pointer transform duration-500 hover:-translate-y-1">
  <img
    className="w-full max-h-[400px] rounded-lg object-cover md:w-80"
    src={donation.imageUrl || "https://www.foodiesfeed.com/wp-content/uploads/2023/06/pouring-honey-on-pancakes.jpg"}
    alt={donation.foodname}
  />
  <div className="w-full">
    <div className="p-5">
      <h1 className="text-2xl font-semibold text-gray-800">
        {donation.foodname}
      </h1>

      <div className="flex items-center mt-2">
        <span className="text-black leading-relaxed">Food Category:</span>
        <span className="text-gray-400 leading-relaxed ml-2">
          {donation.category}
        </span>
      </div>

      <div className="flex items-center mt-2">
        <span className="text-black leading-relaxed">Meal Type:</span>
        <span className="text-gray-400 leading-relaxed ml-2">
          {donation.mealType}
        </span>
      </div>

      <div className="flex items-center mt-2">
        <span className="text-black leading-relaxed">Quantity:</span>
        <span className="text-gray-400 leading-relaxed ml-2">
          {donation.quantity}
        </span>
      </div>
      <div className="flex items-center mt-2">
        {donation.category === "cooked-food" && (
          <span className="text-black leading-relaxed">Date and Time Of Cooking:</span>
       )}
        {donation.category === "raw-food" && (
           <span className="text-black leading-relaxed">Expected Expiry Date:</span>
       )}
        {donation.category === "packed-food" && (
           <span className="text-black leading-relaxed">Expiry Date:</span>
       )}
       
       
        <span className="text-gray-400 leading-relaxed ml-2">
          {new Date(donation.dateOfCooking).toLocaleString()}
        </span>
      </div>
    </div>

    <div className="bg-blue-50 p-5">
      <div className="sm:flex sm:justify-between">
      <div>
        
 
  {/* <div className="flex items-start text-gray-600 ml-0 text-sm md:text-base mt-1">
    <p className="mr-1 text-gray-900 font-bold">Name:</p>
    <span>
    {donation.contact?.name || 'User/Organization Name'}
    </span>
  </div> */}

  

  {/* {selectedContact && donation.interested && (<div className="flex items-start text-gray-600 ml-0 text-sm md:text-base mt-1">
    <p className="mr-1 text-gray-900 font-bold">Phone Number:</p>
    <span>
    <a href={`tel:${selectedContact.phoneno}`} className="text-blue-500">{selectedContact.phoneno}</a>
    </span>
  </div>
  )} */}
  

{/* 
  <div className="flex items-start text-gray-600 ml-0 text-sm md:text-base mt-1">
    <p className="mr-1 text-gray-900 font-bold">Address:</p>
    <span>
      {donation.contact?.address}, {donation.contact?.district}
    </span>
  </div> */}


</div>

        {/* <div>
          <div className="text-lg text-gray-700">
            <span className="text-gray-900 font-bold">
              {donation.contact?.name || 'User/Organization Name'}
            </span>
          </div>

          <div className="flex items-center text-gray-600 ml-2 text-sm md:text-base mt-1">
           <h1> Address:</h1> {donation.contact?.address}, {donation.contact?.district}
          </div>
        </div> */}

        <span className="text-right">
        <button
  disabled={donation.interested}
  className={`m-2 w-48 sm:mt-0 py-2 px-5 md:py-3 md:px-6 font-bold text-white md:text-lg rounded-lg shadow-md ${
    donation.interested ? 'bg-gray-400 cursor-not-allowed' : 'bg-green-500 hover:bg-green-300'
  }`}
  onClick={() => handleInterestClick(donation._id)}
>
  {donation.interested ? 'Already Interested' : 'I am Interested'}
</button>

{/* {donation.interested ? <button className="m-2 w-48 sm:mt-0 py-2 px-5 md:py-3 md:px-6 bg-green-500 hover:bg-green-300 font-bold text-white md:text-lg rounded-lg shadow-md"  onClick={() => handleContactClick(donation.contact)}>
            Contact
          </button> : null} */}
        </span>
      </div>


      {/* {selectedContact && donation.interested && (
        <div className="contact-details p-4 bg-gray-200 rounded-lg shadow-lg mt-4">
          <h2 className="font-bold text-xl">Contact Information</h2>
          <p><strong>Name:</strong> {selectedContact.name}</p>
          <p><strong>Phone Number:</strong> <a href={`tel:${selectedContact.phoneno}`} className="text-blue-500">{selectedContact.phoneno}</a></p>
          <p><strong>Address:</strong> {selectedContact.address}, {selectedContact.district}</p>
        </div>
      )}     */}
  

      <div className="mt-3 text-gray-600 text-sm md:text-sm">
        *Donated on: {new Date(donation.createdAt).toLocaleString()}
      </div>
    </div>
  </div>
</div>

  )}


</>

    ))}



    
   
{/* 
        <div className=" flex  flex-wrap md:flex-nowrap border-2 m-4 rounded-lg shadow-lg mx-auto max-w-3xl group cursor-pointer transform duration-500 hover:-translate-y-1">
          <img
            className="w-full max-h-[400px] rounded-lg object-cover md:w-52"
            src="https://www.foodiesfeed.com/wp-content/uploads/2023/06/pouring-honey-on-pancakes.jpg"
            alt=""
          />
          <div className="w-full">
            <div className=" p-5 ">
              <h1 className="text-2xl font-semibold text-gray-800 ">
                Food Name
              </h1>
              <div className="flex items-center  mt-2">
                <span className=" text-black leading-relaxed">Food Category: </span>
              <span className=" text-gray-400  leading-relaxed ml-2">
                hiiiii 
              </span>
              </div>
              <div className="flex items-center  mt-2">
                <span className=" text-black leading-relaxed">Meal Type: </span>
              <span className=" text-gray-400  leading-relaxed ml-2">
                hiiiii 
              </span>
              </div>
              <div className="flex items-center  mt-2">
                <span className=" text-black leading-relaxed">Quantity: </span>
              <span className=" text-gray-400  leading-relaxed ml-2">
                hiiiii 
              </span>
              </div>

            </div>
            <div className="bg-blue-50 p-5">
              <div className="sm:flex sm:justify-between">
                <div>
                  <div className="text-lg text-gray-700">
                    <span className="text-gray-900 font-bold">User/ORGANIZATION NAME</span>
                  </div>
                    
                    <div className="flex items-center text-gray-600 ml-2 text-sm md:text-base mt-1">
                      Address: Yo YO House jalandhar Punjab, India
                    </div>
                </div>
                <span className='text-right'>
                  <button className="m-2 w-48 sm:mt-0 py-2 px-5 md:py-3 md:px-6 bg-green-500 hover:bg-green-300 font-bold text-white md:text-lg rounded-lg shadow-md">
                    I am Interested
                  </button>
                  <button className="m-2 w-48 sm:mt-0 py-2 px-5 md:py-3 md:px-6 bg-green-500 hover:bg-green-300 font-bold text-white md:text-lg rounded-lg shadow-md">
                    Contact
                  </button>
                </span>
              </div>
              <div className="mt-3 text-gray-600 text-sm md:text-sm">
                *Places to visit: Mahasthangarh, Vasu Bihar &amp; Momo Inn
              </div>
            </div>
          </div>
        </div> */}



   
      

</div>
  )
}

export default FoodList